import { useTranslation } from "react-i18next";
import { statusBadgePalette, type ComplaintKind, type ComplaintStatus } from "../api/complaints";

const STATUS_KEY: Record<ComplaintStatus, string> = {
  SUBMITTED: "submitted",
  IN_REVIEW: "inReview",
  RESOLVED: "resolved",
  REJECTED: "rejected",
  CLOSED: "closed",
};

export function ComplaintStatusBadge({ status }: { status: ComplaintStatus }) {
  const { t } = useTranslation();
  const c = statusBadgePalette(status);
  const label = t(`complaints.status.${STATUS_KEY[status]}`, { defaultValue: status });
  return (
    <span
      style={{
        background: c.bg,
        color: c.fg,
        padding: "2px 8px",
        borderRadius: 999,
        fontSize: 11,
        fontWeight: 600,
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </span>
  );
}

/** What the complaint is about. A complaint filed before the kind existed shows nothing at all. */
export function ComplaintKindTag({ kind }: { kind: ComplaintKind | null }) {
  const { t } = useTranslation();
  if (!kind) return null;
  return <span className="tag neutral">{t(`complaints.kind.${kind}`, { defaultValue: kind })}</span>;
}

/** KK59: an urgent complaint needs no separate channel, but it changes the order the work is done in. */
export function ComplaintUrgentTag({ urgent }: { urgent: boolean }) {
  const { t } = useTranslation();
  if (!urgent) return null;
  return <span className="tag err">{t("complaints.urgent", "Hitno")}</span>;
}
